import { logError } from "@app/utils/log";

type DidomiType = {
	isConsentRequired: () => boolean;
	getObservableOnUserConsentStatusForVendor: (vendorId: string) => any;
	getRequiredVendors: () => { name; id; purposeIds; legIntPurposeIds }[];
	getVendorObject: (vendorId: string) => { name };
	openTransaction: () => {
		enableVendor: (vendorId: string) => void;
		disableVendor: (vendorId: string) => void;
		enablePurpose: (purposeId: string) => void;
		commit: () => void;
	};
};

declare const Didomi: DidomiType;

import { consentVendorsStore } from '../stores/consent';
import { get } from 'svelte/store';

export const listenToVendorConsent = (id) => {
	if (Didomi.isConsentRequired()) {
		// Consent is required: your visitor is from the EU or you are an EU company
		// Only enable the vendor when consent is given
		Didomi.getObservableOnUserConsentStatusForVendor(id).subscribe(
			function (consentStatusForVendor) {
				// The consent status for the vendor has changed
				const store = get(consentVendorsStore);
				if (consentStatusForVendor === true) {
					// The vendor has consent
					store[id].consent = true;
				} else if (consentStatusForVendor === false) {
					store[id].consent = false;
				} else if (consentStatusForVendor === undefined) {
					// The consent status for the vendor is unknown
					store[id].consent = undefined;
				}
				consentVendorsStore.set(store);
			}
		);
	} else {
		// Consent is not required, enable your vendor immediately
	}
};

export const getVendorObject = (vendorId) =>
	Didomi.getRequiredVendors().filter((v) => v.id === vendorId)[0];

export const getVendorId = (src: string): string => {
	let vendorId;

	if (src?.includes('vimeo')) {
		vendorId = 'c:vimeo';
	} else if (src?.includes('youtube') || src?.includes('youtu.be')) {
		vendorId = 'c:youtube';
	} else if (src?.includes('dai.ly') || src?.includes('dailymotion')) {
		vendorId = 573;
	} else if (src?.includes('slideshare')) {
		vendorId = 'c:slideshare-dJj48yP2';
	}
	return vendorId;
};

export const getVendorName = (vendorId) => {
	return getVendorObject(vendorId).name || 'Dailymotion SA';
};

export const getVendorPurposes = (vendorId) => {
	const vendorObj = getVendorObject(vendorId);
	const purposes = vendorObj.purposeIds;
	const legIntPurposes = vendorObj.legIntPurposeIds;
	const allPurposes = purposes.concat(legIntPurposes);
	return allPurposes;
};

export const enableVendor = (vendorId) => {
	if (Didomi) {
		const transaction = Didomi.openTransaction();
		transaction.enableVendor(vendorId);
		const purposes = getVendorPurposes(vendorId);
		purposes.forEach((p) => {
			transaction.enablePurpose(p);
		});
		transaction.commit();
	} else {
		logError('Didomi not initialized');
	}
};

export const hasConsentMatomoVendor = (consentVendorsStore: any): boolean => {
	return consentVendorsStore !== {} && consentVendorsStore['c:matomo-EgfckqpC']?.consent;
};
